<script>
import { mapGetters } from 'vuex'
import TabBase from './tabs/Base'
import TabUsers from './tabs/Users'
import TabAddresses from './tabs/Addresses'
import TabServices from './tabs/Services'
import Roles from '@/mixins/Roles'
export default {
    name: 'CompaniesView',

    components: { TabBase, TabUsers, TabAddresses, TabServices },

    mixins: [Roles],

    computed: mapGetters({ company: 'company' }),

    watch: {
        $route: 'fetch',
    },

    mounted() {
        this.$store.dispatch('title', this.$t('COMPANIES.VIEW'))
        this.fetch()
    },

    methods: {
        fetch() {
            this.$store.dispatch('title', this.$t('COMPANIES.VIEW'))
            this.$store.dispatch('companiesFetch', this.$route.params.company)
        },
    },
}
</script>

<template lang="pug">
div(v-if="company && company.id")
    acrm-top-panel.p-3
        .row
            .col
                .row
                    .col-auto.flex-center-v.align-content-center.justify-content-center
                        acrm-avatar(large :name="company.name")
                    .col.col-sm-auto.flex-center-v
                        acrm-heading(:level="2").mb-0 {{ company.name }}
                    .col-24.col-lg

            .col-auto
                .text-right
                    acrm-input-button-dropdown(variant="link" icon="more_horiz" no-handle large align-right)


    acrm-tabs(:key="`company-${company.id}`")
        acrm-tab(:name="$t('BASE.BASEDATA')" tabKey="base-data")
            tab-base

        acrm-tab(:name="$t('COMPANIES.USERS', { num: company.users ? company.users.length : 0 })" tabKey="users" v-if="hasRoleView('company.fields.users')")
            tab-users

        acrm-tab(:name="$t('COMPANIES.ADDRESSES', { num: company.addresses ? company.addresses.length : 0 })" tabKey="addresses" v-if="hasRoleView('company.fields.addresses')")
            tab-addresses

        acrm-tab(:name="$t('COMPANIES.SERVICES' )" tabKey="services" v-if="hasRoleView('company.fields.services')")
            tab-services

</template>
